import { useTranslation } from 'react-i18next'
import BrandWordmark from './BrandWordmark'

type Props = {
  className?: string
  /** card = listing grid; detail = product modal; thumb = cart/compare mini */
  variant?: 'card' | 'detail' | 'thumb'
  /** Override default “No photo” caption (i18n key). */
  labelKey?: string
}

function PhoneSilhouette() {
  return (
    <svg className="listing-no-photo__phone" viewBox="0 0 72 96" aria-hidden="true">
      <rect x="14" y="6" width="44" height="84" rx="10" fill="none" stroke="currentColor" strokeWidth="2.2" />
      <rect x="30" y="12" width="12" height="3.5" rx="1.75" fill="currentColor" opacity="0.35" />
      <circle cx="36" cy="48" r="11" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.55" />
      <path
        d="M24 72h24"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.28"
      />
    </svg>
  )
}

export default function ListingNoPhotoPlaceholder({
  className = '',
  variant = 'card',
  labelKey = 'catalog.noPhoto',
}: Props) {
  const { t } = useTranslation()
  const variantClass = variant === 'card' ? '' : ` listing-no-photo--${variant}`
  const isBuilderPreview = className.includes('listing-no-photo--builder-preview')
  const brandClass =
    variant === 'detail' && !isBuilderPreview
      ? 'brand-wordmark--auth'
      : 'brand-wordmark--listing-photo'
  const label = t(labelKey)

  return (
    <div
      className={`listing-no-photo${variantClass}${className ? ` ${className}` : ''}`.trim()}
      role="img"
      aria-label={label}
    >
      <div className="listing-no-photo__inner">
        <PhoneSilhouette />
        {variant !== 'thumb' ? (
          <>
            <BrandWordmark
              watermark
              className={`listing-no-photo__brand ${brandClass}`}
            />
            <span className="listing-no-photo__label">{label}</span>
          </>
        ) : null}
      </div>
    </div>
  )
}
